<template>
    <BaseFilter>
        <template slot="filter">
            <ratings-filter class="w-full sticky"/>
        </template>
        <template>
            <div 
                v-if="statisticsRatings.length > 1"
                class="w-full shadow-drop rounded relative overflow-hidden items-no-padding mb-6" 
                style="background-color: white">
                <statistics />
            </div>
            <div>
                <div class="w-full mb-2" v-if="statisticsRatings.length">
                    <average-ratings />
                </div>

                <comments class="w-full" />
            </div>
        </template>
      
    </BaseFilter>
</template>

<script>
    import Statistics from '@/components/ratings/Statistics'
    import RatingsFilter from '@/components/ratings/Filter'
    import Comments from '@/components/ratings/Comments'
    import AverageRatings from '@/components/ratings/AverageRatings'
    import BaseFilter from '@/views/BaseView';

    import { mapMutations, mapGetters } from 'vuex'

    export default {
        components : {
            AverageRatings,
            Statistics,
            RatingsFilter,
            Comments,
            BaseFilter
        },

        data () {
            return {

            }
        },

        mounted () {
            this.clearFields()
        },

        computed : {
            ...mapGetters('ratings', ['statisticsRatings', 'averageRating'])
        },

        methods : {
            ...mapMutations('ratings', ['clearFields'])
        }
    }
</script>

<style>
 .sticky {
    position: sticky;
    top: 90px; 
 }
</style>